export default {
	"order.DontLeaveTheSystemIsGettingThePaymentResult": "請勿離開，系統正在獲取支付結果~",
	"order.DoNotLeaveTheSystemIsGettingThePaymentResultTheTerminationProcessMayAffectTheContentArrival": "請勿離開，系統正在獲取支付結果,終止流程可能影響內容到賬~",
	"order.SuccessfullyPaidJumpingIn": "已支付成功，正在跳轉中...",
	"order.SorryFailedToInitiatePayment": "抱歉，發起支付失敗！",
	"order.PaymentFailed": "支付失敗!",
	"order.paymentSuccessful": "支付成功",
	"order.TheSystemIsTryingToGetThePaymentResultInformationCheckThePaymentDetailsAndTry": "系統正在努力獲取支付結果信息，查看支付詳情試試。",
	"order.ParameterError": "參數錯誤!",
	"order.AfterThePaymentIsSuccessfulTheVirtualGoodsInTheOrderNeedToBeActivatedBeforeTheyCanBeUsed": "支付成功後，訂單中含有虛擬商品需要激活才能使用哦",
	"order.CallingRequiresYourWeChatAuthorizationInOrderToAddExperienceContentToYourAccount": "叫叫需要您的微信授權，以便給您的賬戶下添加體驗內容",
	"order.DoNotLeave": "請勿離開!",
	"order.retryNow": "立即重試"
}